export default '{0} has {1} errors';